module.exports = __webpack_public_path__ + "img/topup_grey.754c671c.svg";